module.exports = __webpack_public_path__ + "img/sim_card_download.d865a94d.svg";